import React, { useState } from "react";

const IPInfo = () => {
  const [ipAddress, setIpAddress] = useState("");
  const [geoInfo, setGeoInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const apiKey = "2a5b326ca86a59";

  const fetchGeoInfo = async () => {
    setLoading(true);
    setError(null);

    const url = `https://ipinfo.io/${ipAddress}/json?token=${apiKey}`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("IP geolocation request failed");
      }
      const data = await response.json();
      console.log(data);

      setGeoInfo(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    setIpAddress(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    fetchGeoInfo();
  };

  return (
    <div className="IPInfo">
      <h2>IP Geolocation Info</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Enter IP Address:
          <input
            className="ip-input"
            type="text"
            value={ipAddress}
            onChange={handleChange}
            placeholder={
              ipAddress ? "" : "Type or click 'Get IP Info' for your IP"
            }
          />
        </label>{" "}
        <br />
        <button type="submit" disabled={loading}>
          {loading ? "Loading..." : "Get IP Info"}
        </button>
      </form>
      {error && <p className="error">{error}</p>}
      {geoInfo && (
        <div>
          <p>IP Address: {geoInfo.ip}</p>
          <p>Country: {geoInfo.country}</p>
          <p>Region: {geoInfo.region}</p>
          <p>City: {geoInfo.city}</p>
          <p>Location: {geoInfo.loc}</p>
          <p>ISP: {geoInfo.org}</p>
        </div>
      )}
    </div>
  );
};

export default IPInfo;
